import trainActionTypes from "./train.types";

export const detailsFetchStart = () => ({
    type: trainActionTypes.DETAILS_FETCH_START
})
export const setLoggedIn = () => ({
    type: trainActionTypes.LOGGED_IN
})
export const detailsFetchSuccess = (data) => ({
    type: trainActionTypes.DETAILS_FETCH_SUCCESS,
    payload: data
})
export const detailsFetchFail = (data) => ({
    type: trainActionTypes.DETAILS_FETCH_FAIL,
    payload: data
})
export const passengerfetchStart = () => ({
    type: trainActionTypes.PASSENGER_DETAILS_FETCH_START
})
export const setrailyatriID = (data) => ({
    type: trainActionTypes.SET_RAILYATRI_ID,
    payload: data
})
export const setUrlData = (data) => ({
    type: trainActionTypes.SET_URL_DATA,
    payload: data
})
export const setOffset = () => ({
    type: trainActionTypes.SET_OFFSET
})
export const setType = (data) => ({
    type: trainActionTypes.SET_TYPE,
    payload: data
})
export const setBugText = (data) => ({
    type: trainActionTypes.SET_BUG_TEXT,
    payload: data
})
export const setFeedbackText = (data) => ({
    type: trainActionTypes.SET_FEEDBACK_TEXT,
    payload: data
})
export const sendPostStart = () => ({
    type: trainActionTypes.SEND_POST_START
})
export const sendPostSuccess = (data) => ({
    type: trainActionTypes.SEND_POST_SUCCESS,
    payload: data
})
export const sendPostFail = (data) => ({
    type: trainActionTypes.SEND_POST_FAIL,
    payload: data
})
export const setImagesBug = (data) => ({
    type: trainActionTypes.SET_IMAGES_BUG,
    payload: data
})
export const setImagesFeedback = (data) => ({
    type: trainActionTypes.SET_IMAGES_FEEDBACK,
    payload: data
})